export enum ETwoFactorAuthFormType {
  CONNECT_FORM = 'connect-form',
  MESSAGE_SENT_FORM = 'message-sent-form',
  QR_CODE_FORM = 'qr-code-form',
  PORTAL_2FA_FORM = 'portal-2fa-form',
}
